module.exports = __webpack_public_path__ + "static/media/q1.fe3ba18d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/endtest/q1/q1.jpg
// module id = 247
// module chunks = 0